module.exports = __webpack_public_path__ + "static/wireframes-4-879c66e30334cb4bcd455b37828ef555.jpg";